<template>
  <aside class="cebianlan">
    <div class="lm-aside">
      <div class="lm-loaction">
        <h3 class="area" id="area">{{area}}<span v-if="stractname!=''">({{stractname}})</span></h3>
        <p class="obj-count" v-if="titNumber">找到<span v-text="number"></span>所{{textjG}}</p>
      </div>
      <div v-if="toback" class="backoff" v-on:click='backa()' title="点击返回"><i class="iconfont icon-back"></i></div>
      <!-- 地址筛选 -->
      <div class="filter-list" v-bind:class="{move: show}">
        <ul>
          <li v-for="(item,index) in zoomCode" v-on:click="shoa(index,item,item.count,item.code,item.name);"
            v-if="item['longitudeGD']"
            v-on:mouseover="hoverCityOvera(item)" v-on:mouseout="hoverCityOuta(item)">
            <a href="javascript:;" class="list-item">
              <span class="item-add" v-text="item.name"></span>
              <span class="item-total"><strong v-text="item.count"></strong>所</span>
            </a>
          </li>
        </ul>
      </div>
      <!--街道筛选-->
      <div class="street-list" v-bind:class="{move: showstr}">
        <ul>
          <li v-for="(item,index) in stract" v-if="item.number!=0" v-on:click="abaa(item.code,item.count,item.name,index, item)">
            <a href="javascript:;" class="list-item">
              <span class="item-add" v-text="item.name"></span>
              <span class="item-total"><strong v-text="item.count"></strong>所</span>
            </a>
          </li>
        </ul>
      </div>
      <!-- 机构卡片 -->
      <div class="org-list" v-bind:class="{move: sshow}">
        <div class="lm-filter-wrap clearfix">
          <div class="lm-filter-item pull-left" v-for="(item, index) in listArr" :class="{active: item.active}" @click="screen({arr: item, ind: index})">
              <span>{{item.name}}</span>
              <div class="lm-filter-child" v-if="item.innerArr">
                <div class="filter-child-item" v-for="(innerItem, itemIndex) in item.innerArr" :class="{active: innerItem.activeInner}" @click="screenInner({arr: innerItem, ind: itemIndex})">{{innerItem.name}}</div>
              </div>
          </div>
          <!-- <div class="lm-filter-item pull-left active">
            <span>综合</span>
          </div>
          <div class="lm-filter-item pull-left">
            <span>好评率</span>
          </div>
          <div class="lm-filter-item pull-left">
            <span>距离</span>
          </div>
          <div class="lm-filter-item pull-left">
            <span>更多</span>
            <div class="lm-filter-child">
              <div class="filter-child-item active">按成立时间排序</div>
              <div class="filter-child-item">按公益积分排序</div>
              <div class="filter-child-item">按信用积分排序</div>
            </div>
          </div> -->
        </div>
        <ul>
          <li v-for="(item,index) in resuList" v-on:click="aaba(item.properties.name)">
            <a href="javascript:;" class="org-item">
              <div class="thumb-wrap">
                <div class="thumb" style="background-image:url('static/images/default_org.jpg');"></div>
                <div class="org-type blue" v-if="item.typeName === '律师事务所'">律所</div>
                <div class="org-type orange" v-if="item.typeName === '法律服务所'">服务所</div>
                <div class="org-type green" v-if="item.typeName === '人民调解委员会'">人民调解</div>
                <div class="org-type red" v-if="item.typeName === '司法鉴定所'">司法鉴定</div>
                <div class="org-type teal" v-if="item.typeName === '法援机构'">法律援助</div>
                <div class="org-type cyan" v-if="item.typeName === '公证处'">公证处</div>
                <div class="org-type pink" v-if="item.typeName === '司法局'">社区工作</div>
              </div>
              <h4 class="org-name" v-text="item.properties.name">北京大成律师事务所（上海分所）</h4>
              <div class="org-info"><i class="iconfont icon-tel"></i><span>{{item.properties.phone}}</span></div>
              <div class="org-info">
                <i class="iconfont icon-local"></i>
                <span v-if="item.properties.address">{{item.properties.address}}</span>
                <span v-else>{{item.properties.domicileAddress}}</span>
              </div>
              <div class="org-distance">{{item.distance}}</div>
            </a>
          </li>
          <div v-if="tpage>=20" class="res-inn but-up" v-on:click="ajaxdowna()">上一页</div>
          <div v-if="tpage>=20 && !(pagenum/detailnum===1)" class="res-inn but-dowm" v-on:click="ajaxupa()">下一页</div>
          <div v-if="tpage>=20 && (pagenum/detailnum===1)" class="res-inn but-dowm">下一页</div>
          <div v-if="tpage>=20" class="res-num-ber">{{pagenum}}/{{detailnum}}</div>
        </ul>
      </div>
      <!--loading-->
      <div class="loding-page" v-bind:class="{lodmove: lodshow}">
        <div class="loding-img">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div id="app">
      </div>
    </div>
  </aside>
</template>
<script>
  export default {
    props: [
      'area',
      'stractname',
      'titNumber',
      'number',
      'show',
      'zoomCode',
      'sho',
      'hoverCityOver',
      'hoverCityOut',
      'showstr',
      'stract',
      'aba',
      'sshow',
      'resuList',
      'aab',
      'tpage',
      'ajaxdown',
      'ajaxup',
      'pagenum',
      'detailnum',
      'lodshow',
      'standbynumber',
      'back',
      'toback',
      'textjG'
    ],
    data () {
      return {
        numbera: this.number,
        listArr: [
          {name: '综合', active: true},
          {name: '好评率', active: false},
          {name: '成立时间', active: false},
          {
            name: '更多',
            active: false,
            innerArr: [
              {name: '按公益积分排序', activeInner: false},
              {name: '按成信用排序', activeInner: false}
            ]
          }
        ]
      }
    },
    watch: {
      number: function () {
        this.numbera = this.standbynumber
      }
    },
    methods: {
      screen: function (arr) {
        let len = this.listArr.length
        for (let i = 0; i < len; i++) {
          this.listArr[i].active = false
        }
        this.listArr[arr.ind].active = true
      },
      screenInner: function (arr) {
        let len = this.listArr[3].innerArr.length
        for (let i = 0; i < len; i++) {
          this.listArr[3].innerArr[i].activeInner = false
        }
        this.listArr[3].innerArr[arr.ind].activeInner = true
      },
      shoa: function (index, item, num, code, name) {
        this.sho(index, item, num, code, name)
      },
      abaa: function (code, num, name, index, item) {
        this.aba(code, num, name, index, item)
      },
      aaba: function (inner) {
        this.aab(inner)
      },
      ajaxdowna: function () {
        this.ajaxdown()
      },
      ajaxupa: function () {
        this.ajaxup()
      },
      hoverCityOuta: function (item) {
        this.hoverCityOut(item)
      },
      hoverCityOvera: function (item) {
        this.hoverCityOver(item)
      },
      backa: function () {
        this.back()
      }
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">

    @import '../assets/scss/variables';
    @import '../assets/scss/mixins';
    .cebianlan {
      position: relative;
      right: 0;
      top: 0;
      width: 350px;
      height: 100%;
    }

    .lm-aside {
      position: relative;
      left: 0;
      top: 0;
      width: 350px;
      height: 100%;
      border-left: 1px solid rgba(0, 0, 0, .08);
      box-shadow: -1px 0 3px rgba(0, 0, 0, .03);
      background-color: $white;
      overflow-x: hidden;
    }

    .backoff{
      z-index: 51;
      position: fixed;
      right: 15px;
      height: 82px;
      line-height: 82px;
      cursor: pointer;
      color: #aaa;
      &:hover{
        color: $brand;
      }
      .iconfont{
        font-size: $font-size-h1;
      }
    }
    .lm-loaction {
      position: fixed;
      right: 0;
      top: 60px;
      padding: $module-padding;
      background-color: #f6f6f6;
      border-bottom: 1px solid #eaeaea;
      width: 350px;
      height: 82px;
      z-index: 50;
      .area {
        position: relative;
        width: 100%;
        display: block;
        margin: 0;
        font-size: $font-size-h4;
        color: $gray-dark;
        span {
          width: 75%;
          height: 100%;
          padding-top: 5px;
          float: right;
          display: block;
          font-size: 14px;
          color: $gray-light;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
      }
      .obj-count {
        margin: 0;
        padding-top: 5px;
        font-size: 15px;
        color: $gray-light;
        span {
          padding: 0 5px;
          font-weight: 700;
          color: $brand;
        }
      }
    }
    .lm-filter-wrap {
      position: relative;
      width: 100%;
      height: 44px;
      background-color: #e8e8e8;
      .lm-filter-item {
        position: relative;
        width: 25%;
        height: 100%;
        text-align: center;
        line-height: 44px;
        cursor: pointer;
        font-size: $font-size-base;
        color: #333;
        &.active {
          color: $brand;
          span:before {
            border-top: 8px solid $brand;
          }
        }
        &:hover {
          color: $brand;
          span:before {
            border-top: 8px solid $brand;
          }
          .lm-filter-child {
            display: block;
          }
        }
        span {
          position: relative;
          display: inline-block;
          &:before {
            content: '';
            display: block;
            position: absolute;
            right: -14px;
            top: 50%;
            width: 0;
            height: 0;
            margin-top: -4px;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 8px solid #333;
          }
        }
      }
      .lm-filter-child {
        display: none;
        position: absolute;
        left: -56px;
        top: 42px;
        z-index: 999;
        width: 142px;
        text-align: left;
        border: 1px solid #ddd;
        background-color: $white;
      }
      .filter-child-item {
        padding-left: 12px;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #ddd;
        font-size: $font-size-base;
        color: #666;
        &:hover,
        &.active {
          color: $brand;
        }
        &:last-child {
          border-bottom: 0;
        }
      }
    }

    // 区域列表
    .filter-list {
      transition: all .3s ease;
      position: absolute;
      left: 0;
      top: 80px;
      width: 100%;
      z-index: 10;
      background: $white;
      ul {
        margin: 0;
        padding: 0 $module-padding;
        width: 100%;
        list-style: none;
        li {
          border-top: 1px solid $gray-lighter;
          &:first-child {
            border-top: none;
          }
        }
      }
      .list-item {
        position: relative;
        display: block;
        padding-left: 4px;
        padding-right: 20px;
        height: 44px;
        line-height: 44px;
        color: $gray-dark;
        @include clearfix;
        &:after {
          content: '\e645';
          position: absolute;
          right: 0;
          top: 2px;
          display: inline-block;
          font-family: "iconfont" !important;
          font-size: $font-size-base;
          color: #bbb;
        }
        &:hover {
          color: $brand;
          background-color: #fafafa;
        }
        .item-total {
          float: right;
          font-size: $font-size-base;
          color: $gray-light;
          strong {
            padding-right: 4px;
            font-weight: normal;
          }
        }
      }
    }

    //街道列表
    .street-list {
      transition: all .3s ease;
      position: absolute;
      left: -100%;
      top: 80px;
      width: 100%;
      z-index: 20;
      background: $white;
      ul {
        margin: 0;
        padding: 0 $module-padding;
        width: 100%;
        list-style: none;
        li {
          border-top: 1px solid $gray-lighter;
          &:first-child {
            border-top: none;
          }
        }
      }
      .list-item {
        position: relative;
        display: block;
        padding-left: 4px;
        padding-right: 20px;
        height: 44px;
        line-height: 44px;
        color: $gray-dark;
        @include clearfix;
        &:after {
          content: '\e645';
          position: absolute;
          right: 0;
          top: 2px;
          display: inline-block;
          font-family: "iconfont" !important;
          font-size: $font-size-base;
          color: #bbb;
        }
        &:hover {
          color: $brand;
          background-color: #fafafa;
        }
        .item-total {
          display: block;
          float: right;
          font-size: $font-size-base;
          color: $gray-light;
          strong {
            padding-right: 4px;
            font-weight: normal;
          }
        }
      }
      .item-add {
        display: block;
        float: left;
        width: 200px;
        height: 100%;
        overflow: hidden;
      }
    }

    // 机构列表
    .org-list {
      transition: all .3s ease;
      position: absolute;
      left: -100%;
      top: 80px;
      width: 100%;
      min-height: calc(100% - 126px);
      overflow: hidden;
      z-index: 30;
      background: $white;
      ul {
        margin: 0;
        padding: 0;
        width: 100%;
        list-style: none;
        li {
          border-top: 1px solid $gray-lighter;
          &:first-child {
            border-top: none;
          }
        }
      }
      .org-item {
        position: relative;
        display: block;
        padding: $module-padding 10px;
        @include clearfix();
        .thumb-wrap {
          overflow: hidden;
          float: left;
          width: 56px;
        }
        .thumb {
          overflow: hidden;
          margin-top: 2px;
          width: 56px;
          height: 50px;
          border: 1px solid $gray-lighter;
          border-bottom: none;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          transition: all 1s;
        }
        .org-distance {
          position: absolute;
          right: 20px;
          bottom: 17px;
          padding-left: 10px;
          padding-right: 10px;
          box-sizing: border-box;
          background: $white;
        }
        .org-type {
          z-index: 10;
          position: relative;
          width: 100%;
          text-align: center;
          font-size: $font-size-small;
          font-family: $font-family-more;
          @include text-overflow();
          color: $white;
          background-color: $gray-light;
          &.blue {
            background-color: $brand-blue;
          }
          &.red {
            background-color: $brand-red;
          }
          &.green {
            background-color: $brand-green;
          }
          &.orange {
            background-color: darken($brand-orange, 5%);
          }
          &.cyan {
            background-color: $brand-cyan;
          }
          &.teal {
            background-color: $brand-teal;
          }
          &.pink {
            background-color: $brand-pink;
          }
        }
        .org-name {
          padding-bottom: 4px;
          margin: 0 0 0 65px;
          font-size: 15px;
          color: $gray-dark;
          @include text-overflow();
        }
        .org-info {
          margin: 0 0 0 65px;
          padding-top: 2px;
          padding-right: 50px;
          color: $gray-light;
          @include text-overflow();
        }
        .iconfont {
          vertical-align: middle;
          padding-right: 5px;
          font-size: $font-size-base;
          color: #bbb;
        }
        &:hover {
          background-color: #fafafa;
          .thumb {
            transform: scale(1.1);
          }
          .org-name {
            color: $brand;
          }
          .org-distance {
            background-color: #fafafa;
          }
        }
      }
    }

    //loding
    .loding-page {
      position: absolute;
      left: 0;
      top: 50%;
      width: 100%;
      height: 50%;
      display: none;
      overflow: hidden;
      padding-left: 700px;
      z-index: 30;
      background: $white;
    }

    .loding-page.lodmove {
      display: block;
    }

    .result-box {
      transition: all .3s ease;
      position: absolute;
      left: 0;
      top: 80px;
      width: 100%;
      list-style: none;
      margin: 0;
      padding: 0;
      padding-left: 20px;
      padding-right: 10px;
      .result-inner {
        height: 42px;
        border-bottom: 1px solid $gray-lighter;
        line-height: 42px;
        cursor: pointer;
        &:hover {
          background: rgba(3, 3, 3, 0.1);
        }
      }
    }

    .result-box.move {
      left: 100%;
    }

    .result-list-box {
      transition: all .3s ease;
      position: absolute;
      left: -100%;
      top: 80px;
      width: 100%;
      background: $white;
      list-style: none;
      margin: 0;
      padding: 0;
      padding-left: 20px;
      padding-right: 10px;
      .result-list-inner {
        height: 42px;
        border-bottom: 1px solid $gray-lighter;
        line-height: 42px;
        cursor: pointer;
        &:hover {
          background: rgba(3, 3, 3, 0.1);
        }
      }
    }

    .result-list-box.move {
      left: 0;
    }

    .res-inn {
      width: 50%;
      height: 30px;
      background: $white;
      float: left;
      text-align: center;
      line-height: 30px;
      color: $gray-dark;
      cursor: pointer;
    }

    //Ui
    .filter-list.move {
      left: 100%;
    }

    .org-list.move {
      left: 0;
    }

    .street-list.move {
      left: 0;
    }

    .res-num-ber {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 30px;
      height: 30px;
      text-align: center;
      line-height: 30px;
    }
  .go-back {
    color: red;
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// aside.vue?4e01138d